<template>
  <div class="l-container StudentsIndexInheritance">
    現在表示数 {{max}}
    <!-- <div>{{obj}}</div> -->

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span>
      <template v-if="this.sortColumn === 'id'">ID</template>
      <template v-if="this.sortColumn === 'office_id'">営業所</template>
      <template v-if="this.sortColumn === 'user_id'">登録者</template>
      <template v-if="this.sortColumn === 'state'">状態</template>
      <template v-if="this.sortColumn === 'address'">住所</template>
      <template v-if="this.sortColumn === 'name'">名前</template>
      <template v-if="this.sortColumn === 'kana'">かな</template>
      <template v-if="this.sortColumn === 'age'">年齢</template>
      <template v-if="this.sortColumn === 'grade'">学年</template>
      <template v-if="this.sortColumn === 'takeover_time'">引継時期</template>
      <template v-if="this.sortColumn === 'inheritance_result'">引継結果</template>
      <template v-if="this.sortColumn === 'next_contact_date'">次回TEL日</template>
      <template v-if="this.sortColumn === 'service_period_start'">役務開始</template>
      <template v-if="this.sortColumn === 'service_period_end'">役務終了</template>
      <template v-if="this.sortColumn === 'agreements'">契約情報</template>
       : {{sortState}}
    </span>

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="def()">DEFAULT</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('office_id')" v-bind:class="{ 'active': office_id }">営業所</btn>
        <btn class="m-btn--column" @click.native="switchV('user_id')" v-bind:class="{ 'active': user_id }">登録者</btn>
        <btn class="m-btn--column" @click.native="switchV('state')" v-bind:class="{ 'active': state }">状態</btn>
        <btn class="m-btn--column" @click.native="switchV('address')" v-bind:class="{ 'active': address }">住所</btn>
        <btn class="m-btn--column" @click.native="switchV('name')" v-bind:class="{ 'active': name }">名前</btn>
        <btn class="m-btn--column" @click.native="switchV('kana')" v-bind:class="{ 'active': kana }">かな</btn>
        <btn class="m-btn--column" @click.native="switchV('age')" v-bind:class="{ 'active': age }">年齢</btn>
        <btn class="m-btn--column" @click.native="switchV('grade')" v-bind:class="{ 'active': grade }">学年</btn>
        <btn class="m-btn--column" @click.native="switchV('takeover_time')" v-bind:class="{ 'active': takeover_time }">引継時期</btn>
        <btn class="m-btn--column" @click.native="switchV('inheritance_result')" v-bind:class="{ 'active': inheritance_result }">引継結果</btn>
        <btn class="m-btn--column" @click.native="switchV('next_contact_date')" v-bind:class="{ 'active': next_contact_date }">次回TEL日</btn>
        <btn class="m-btn--column" @click.native="switchV('service_period_start')" v-bind:class="{ 'active': service_period_start }">役務開始</btn>
        <btn class="m-btn--column" @click.native="switchV('service_period_end')" v-bind:class="{ 'active': service_period_end }">役務終了</btn>
        <btn class="m-btn--column" @click.native="switchV('agreements')" v-bind:class="{ 'active': agreements }">契約情報</btn>
      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <template v-if="id"><td-c class="sticky-1"><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
          <template v-if="office_id">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="user_id">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.user_id" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="state">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.state" :options="stateSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="address"><td-c class="sticky-1"><input v-model="search.address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c class="sticky-1"><input v-model="search.name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="kana"><td-c class="sticky-1"><input v-model="search.kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="age"><td-c class="sticky-1"><input v-model="search.age[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="age"><td-c class="sticky-1"><input v-model="search.age[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="grade">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.grade" :options="gradeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="takeover_time"><td-c class="sticky-1"><input v-model="search.takeover_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="inheritance_result">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.inheritance_result" :options="inheritance_resultSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="next_contact_date"><td-c class="sticky-1"><input v-model="search.next_contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="service_period_start"><td-c class="sticky-1"><input v-model="search.service_period_start" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="service_period_end"><td-c class="sticky-1"><input v-model="search.service_period_end" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="agreements">
            <td-c class="select sticky-1">
              <!-- <multiselect @select="searchTable()" v&#45;model="watch.text_type" :options="text_typeSelect" label="name" placeholder="" :show&#45;labels="false"></multiselect> -->
            </td-c>
          </template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
          <template v-if="office_id">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="user_id">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_user_id" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="state">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_state" :options="stateSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="address"><td-c class="sticky-2"><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c class="sticky-2"><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="kana"><td-c class="sticky-2"><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="age"><td-c class="sticky-2"><input v-model="search.not_age[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="age"><td-c class="sticky-2"><input v-model="search.not_age[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="grade">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_grade" :options="gradeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="takeover_time"><td-c class="sticky-2"><input v-model="search.not_takeover_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="inheritance_result">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_inheritance_result" :options="inheritance_resultSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="next_contact_date"><td-c class="sticky-2"><input v-model="search.not_next_contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="service_period_start"><td-c class="sticky-2"><input v-model="search.not_service_period_start" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="service_period_end"><td-c class="sticky-2"><input v-model="search.not_service_period_end" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="agreements">
            <td-c class="select sticky-2">
              <!-- <multiselect @select="searchTable()" v&#45;model="watch.not_text_type" :options="text_typeSelect" label="name" placeholder="" :show&#45;labels="false"></multiselect> -->
            </td-c>
          </template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><th-c class="sticky-3" @click.native='sort("id")'>ID</th-c></template>
          <template v-if="office_id"><th-c class="sticky-3" @click.native='sort("office_id")'>営業所</th-c></template>
          <template v-if="user_id"><th-c class="sticky-3" @click.native='sort("user_id")'>登録者</th-c></template>
          <template v-if="state"><th-c class="sticky-3" @click.native='sort("state")'>状態</th-c></template>
          <template v-if="address"><th-c class="sticky-3" @click.native='sort("address")'>住所</th-c></template>
          <template v-if="name"><th-c class="sticky-3" @click.native='sort("name")'>名前</th-c></template>
          <template v-if="kana"><th-c class="sticky-3" @click.native='sort("kana")'>かな</th-c></template>
          <template v-if="age"><th-c class="sticky-3" @click.native='sort("age")'>年齢</th-c></template>
          <template v-if="age"><th-c class="sticky-3" @click.native='sort("age")'>~年齢</th-c></template>
          <template v-if="grade"><th-c class="sticky-3" @click.native='sort("grade")'>学年</th-c></template>
          <template v-if="takeover_time"><th-c class="sticky-3" @click.native='sort("takeover_time")'>引継時期</th-c></template>
          <template v-if="inheritance_result"><th-c class="sticky-3" @click.native='sort("inheritance_result")'>引継結果</th-c></template>
          <template v-if="next_contact_date"><th-c class="sticky-3" @click.native='sort("next_contact_date")'>次回TEL日</th-c></template>
          <template v-if="service_period_start"><th-c class="sticky-3" @click.native='sort("service_period_start")'>役務開始</th-c></template>
          <template v-if="service_period_end"><th-c class="sticky-3" @click.native='sort("service_period_end")'>役務終了</th-c></template>
          <template v-if="agreements"><th-c class="sticky-3" @click.native='sort("agreements")'>契約情報</th-c></template>
        </tr-c>

        <tr-c @click.native='linkStudent(list)' slot="tr-td" v-for="list in mapStudents" :key="list.id" class="tr_hover">
          <template v-if="id"><td-c>{{list.id}}</td-c></template>
          <template v-if="office_id"><td-c>{{list.office}}</td-c></template>
          <template v-if="user_id"><td-c>{{list.user.user}}</td-c></template>
          <template v-if="state">
            <td-c v-if="list.state === 0">未選択</td-c>
            <td-c v-if="list.state === 1">指導中</td-c>
            <td-c v-if="list.state === 2">休止</td-c>
            <td-c v-if="list.state === 3">CXL</td-c>
            <td-c v-if="list.state === 4">終了</td-c>
          </template>
          <template v-if="address"><td-c>{{list.family.address1}} {{list.family.address2}}</td-c></template>
          <template v-if="name"><td-c v-bind:class="[{ 'men': list.gender === 1 }, { 'women': list.gender === 2 }]">{{list.f_name}} {{list.l_name}}</td-c></template>
          <template v-if="kana"><td-c v-bind:class="[{ 'men': list.gender === 1 }, { 'women': list.gender === 2 }]">{{list.f_name_kana}} {{list.l_name_kana}}</td-c></template>
          <template v-if="age"><td-c>{{list.age}}</td-c></template>
          <template v-if="age"><td-c></td-c></template>
          <template v-if="grade"><td-c>{{list.grade}}</td-c></template>
          <template v-if="takeover_time"><td-c>{{list.takeover_time}}</td-c></template>
          <template v-if="inheritance_result">
            <td-c v-if="list.inheritance_result === 0"></td-c>
            <td-c v-if="list.inheritance_result === 1">成功</td-c>
            <td-c v-if="list.inheritance_result === 2">失敗</td-c>
            <td-c v-if="list.inheritance_result === 3">保留</td-c>
          </template>
          <template v-if="next_contact_date"><td-c>{{list.next_contact_date}}</td-c></template>
          <template v-if="service_period_start"><td-c>{{list.service_period_start}}</td-c></template>
          <template v-if="service_period_end"><td-c>{{list.service_period_end}}</td-c></template>

          <template v-if="agreements">
            <td-c class="agreements">
              <ul style="padding: 0; margin: 0; border-left: solid 1px #ccc; border-top: solid 1px #ccc;">
                <tr-c @click='linkAgreement(list)' v-for="list in list.agreements" :key="list.id + '-agreement'" class="tr_hover">
                  <td-c>{{list.id}}</td-c>
                  <td-c style="min-width: 70px">{{list.service_period_start}}</td-c>
                  <td-c style="min-width: 70px">{{list.service_period_end}}</td-c>
                  <td-c style="min-width: 120px">{{list.text_type}}</td-c>
                </tr-c>
              </ul>
            </td-c>
          </template>

        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/students/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'student',
  pageNames: 'students'
}

let _ = window._
export default {
  props: {

  },
  data () {
    return {
      column: false,
      sortState: '降順',
      sortColumn: 'id',

      id: false,
      office_id: true,
      user_id: true,
      state: true,
      address: true,
      name: true,
      kana: true,
      age: true,
      grade: true,
      takeover_time: true,
      inheritance_result: true,
      next_contact_date: true,
      service_period_start: true,
      service_period_end: true,
      agreements: true,

      search: {
        id: '',
        office_id: '',
        user_id: '',
        state: '',
        address: '',
        name: '',
        kana: '',
        age: [],
        grade: '',
        takeover_time: '',
        inheritance_result: '',
        next_contact_date: '',
        service_period_start: '',
        service_period_end: '',

        text_type: '',

        not_id: '',
        not_office_id: '',
        not_user_id: '',
        not_state: '',
        not_address: '',
        not_name: '',
        not_kana: '',
        not_age: [],
        not_grade: '',
        not_takeover_time: '',
        not_inheritance_result: '',
        not_next_contact_date: '',
        not_service_period_start: '',
        not_service_period_end: '',

        not_text_type: ''
      },

      watch: {
        office_id: '',
        user_id: '',
        state: '',
        grade: '',
        inheritance_result: '',
        text_type: '',

        not_office_id: '',
        not_user_id: '',
        not_state: '',
        not_grade: '',
        not_inheritance_result: '',
        not_text_type: ''
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    stateSelect () {
      return this.$store.getters['students/state']
    },

    gradeSelect () {
      return this.$store.getters['students/grade']
    },

    inheritance_resultSelect () {
      return this.$store.getters['students/inheritance_result']
    },

    text_typeSelect () {
      return this.$store.getters['agreements/text_type']
    },

    offices () {
      return this.$store.getters.offices
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    orderedUsers () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.users, this.sortColumn, 'desc')
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.users, this.sortColumn)
      }
    },

    filteredUsers () {
      let self = this
      if (self.user.office_id === 1) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 1 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 2) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 2 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 3) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 3 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 4) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 4 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 5) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 5 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 6) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 6 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 7) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 7 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 8) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 8 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 9) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 9 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 10) {
        return self.orderedUsers.filter(user => {
          return user.office_id === 10 && user.hide_flag !== 1
        })
      } else {
        return self.orderedUsers.filter(user => {
          return user.hide_flag !== 1
        })
      }
    },

    students () {
      return this.$store.getters.students
    },

    orderedStudents () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.students, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.students, this.sortColumn)
      }
    },

    mapStudents () {
      let self = this
      return self.orderedStudents.map(student => {
        student.age = self.calcAge(student.birthday)
        student.grade = self.calcGrade(student.birthday, student.grade_flag)
        student.office = self.calcOffice(student.office_id)
        return student
      })
    }
  },
  watch: {
    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    },

    'watch.state': function (now, old) {
      if (now) {
        this.search.state = now.value
      } else {
        this.search.state = ''
      }
    },

    'watch.not_state': function (now, old) {
      if (now) {
        this.search.not_state = now.value
      } else {
        this.search.not_state = ''
      }
    },

    'watch.grade': function (now, old) {
      if (now) {
        this.search.grade = now.value
      } else {
        this.search.grade = ''
      }
    },

    'watch.not_grade': function (now, old) {
      if (now) {
        this.search.not_grade = now.value
      } else {
        this.search.not_grade = ''
      }
    },

    'watch.inheritance_result': function (now, old) {
      if (now) {
        this.search.inheritance_result = now.value
      } else {
        this.search.inheritance_result = ''
      }
    },

    'watch.not_inheritance_result': function (now, old) {
      if (now) {
        this.search.not_inheritance_result = now.value
      } else {
        this.search.not_inheritance_result = ''
      }
    },

    'watch.text_type': function (now, old) {
      if (now) {
        this.search.text_type = now.value
      } else {
        this.search.text_type = ''
      }
    },

    'watch.not_text_type': function (now, old) {
      if (now) {
        this.search.not_text_type = now.value
      } else {
        this.search.not_text_type = ''
      }
    }
  },
  methods: {
    calcOffice (val) {
      if (val) {
        return this.offices.filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    calcUser (val) {
      if (val) {
        return this.users.filter(item => {
          return item.id === val
        })[0].user
      } else {
        return
      }
    },

    calcAge (birthday) {
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade (birthday, grade_flag) {
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      let gradeNumber = ageNumber + Number(grade_flag)

      let grade
      if (gradeNumber === 4) {
        grade = '幼稚園年少'
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'
      } else if (gradeNumber === 7) {
        grade = '小学1年生'
      } else if (gradeNumber === 8) {
        grade = '小学2年生'
      } else if (gradeNumber === 9) {
        grade = '小学3年生'
      } else if (gradeNumber === 10) {
        grade = '小学4年生'
      } else if (gradeNumber === 11) {
        grade = '小学5年生'
      } else if (gradeNumber === 12) {
        grade = '小学6年生'
      } else if (gradeNumber === 13) {
        grade = '中学1年生'
      } else if (gradeNumber === 14) {
        grade = '中学2年生'
      } else if (gradeNumber === 15) {
        grade = '中学3年生'
      } else if (gradeNumber === 16) {
        grade = '高校1年生'
      } else if (gradeNumber === 17) {
        grade = '高校2年生'
      } else if (gradeNumber === 18) {
        grade = '高校3年生'
      } else {
        grade = ''
      }
      return grade
    },

    linkStudent (student) {
      this.$router.push({name: 'studentindex', params: { id: student.id }})
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.office_id = false
      this.user_id = false
      this.state = false
      this.address = false
      this.name = false
      this.kana = false
      this.age = false
      this.grade = false
      this.takeover_time = false
      this.inheritance_result = false
      this.next_contact_date = false
      this.service_period_start = false
      this.service_period_end = false
      this.agreements = false
    },

    all () {
      this.id = true
      this.office_id = true
      this.user_id = true
      this.address = true
      this.name = true
      this.kana = true
      this.age = true
      this.grade = true
      this.takeover_time = true
      this.inheritance_result = true
      this.next_contact_date = true
      this.service_period_start = true
      this.service_period_end = true
      this.agreements = true
    },

    def () {
      this.id = false
      this.office_id = true
      this.user_id = true
      this.state = true
      this.address = true
      this.name = true
      this.kana = true
      this.age = true
      this.grade = true
      this.takeover_time = true
      this.inheritance_result = true
      this.next_contact_date = true
      this.service_period_start = true
      this.service_period_end = true
      this.agreements = true
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      this.watch.office_id = 0
      this.watch.user_id = 0
      this.watch.state = 0
      this.search.address = ''
      this.search.name = ''
      this.search.kana = ''
      this.search.age = []
      this.watch.grade = 0
      this.search.takeover_time = ''
      this.watch.inheritance_result = 0
      this.search.next_contact_date = ''
      this.search.service_period_start = ''
      this.search.service_period_end = ''
      this.watch.text_type = 0

      this.search.not_id = ''
      this.watch.not_office_id = 0
      this.watch.not_user_id = 0
      this.watch.not_state = 0
      this.search.not_address = ''
      this.search.not_name = ''
      this.search.not_kana = ''
      this.search.not_age = []
      this.watch.not_grade = 0
      this.search.not_takeover_time = ''
      this.watch.not_inheritance_result = 0
      this.search.not_next_contact_date = ''
      this.search.not_service_period_start = ''
      this.search.not_service_period_end = ''
      this.watch.not_text_type = 0

      this.searchTable()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('StudentsSearch')
      let obj = JSON.parse(getjson)

      vm.search.id = obj['id']
      vm.watch.office_id = obj['office_id']
      vm.watch.user_id = obj['user_id']
      vm.watch.state = obj['state']
      vm.search.address = obj['address']
      vm.search.name = obj['name']
      vm.search.kana = obj['kana']
      vm.search.age = obj['age']
      vm.watch.grade = obj['grade']
      vm.search.takeover_time = obj['takeover_time']
      vm.watch.inheritance_result = obj['inheritance_result']
      vm.search.next_contact_date = obj['next_contact_date']
      vm.search.service_period_start = obj['service_period_start']
      vm.search.service_period_end = obj['service_period_end']

      vm.search.not_id = obj['not_id']
      vm.watch.not_office_id = obj['not_office_id']
      vm.watch.not_user_id = obj['not_user_id']
      vm.watch.not_state = obj['not_state']
      vm.search.not_address = obj['not_address']
      vm.search.not_name = obj['not_name']
      vm.search.not_kana = obj['not_kana']
      vm.search.not_age = obj['not_age']
      vm.watch.not_grade = obj['not_grade']
      vm.search.not_takeover_time = obj['not_takeover_time']
      vm.watch.not_inheritance_result = obj['not_inheritance_result']
      vm.search.not_next_contact_date = obj['not_next_contact_date']
      vm.search.not_service_period_start = obj['not_service_period_start']
      vm.search.not_service_period_end = obj['not_service_period_end']

      vm.id = obj['column_id']
      vm.office_id = obj['column_office_id']
      vm.user_id = obj['column_user_id']
      vm.state = obj['column_state']
      vm.address = obj['column_address']
      vm.name = obj['column_name']
      vm.kana = obj['column_kana']
      vm.age = obj['column_age']
      vm.grade = obj['column_grade']
      vm.takeover_time = obj['column_takeover_time']
      vm.inheritance_result = obj['column_inheritance_result']
      vm.next_contact_date = obj['column_next_contact_date']
      vm.service_period_start = obj['column_service_period_start']
      vm.service_period_end = obj['column_service_period_end']

      vm.agreements = obj['column_agreements']

      // console.log(obj)
      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      id: this.search.id,
      office_id: this.watch.office_id,
      user_id: this.watch.user_id,
      state: this.watch.state,
      address: this.search.address,
      name: this.search.name,
      kana: this.search.kana,
      age: this.search.age,
      grade: this.watch.grade,
      takeover_time: this.search.takeover_time,
      inheritance_result: this.watch.inheritance_result,
      next_contact_date: this.search.next_contact_date,
      service_period_start: this.search.service_period_start,
      service_period_end: this.search.service_period_end,

      not_id: this.search.not_id,
      not_office_id: this.watch.not_office_id,
      not_user_id: this.watch.not_user_id,
      not_state: this.watch.not_state,
      not_address: this.search.not_address,
      not_name: this.search.not_name,
      not_kana: this.search.not_kana,
      not_age: this.search.not_age,
      not_grade: this.watch.not_grade,
      not_takeover_time: this.search.not_takeover_time,
      not_inheritance_result: this.watch.not_inheritance_result,
      not_next_contact_date: this.search.not_next_contact_date,
      not_service_period_start: this.search.not_service_period_start,
      not_service_period_end: this.search.not_service_period_end,

      column_id: this.id,
      column_office_id: this.office_id,
      column_user_id: this.user_id,
      column_state: this.state,
      column_address: this.address,
      column_name: this.name,
      column_kana: this.kana,
      column_age: this.age,
      column_grade: this.grade,
      column_takeover_time: this.takeover_time,
      column_inheritance_result: this.inheritance_result,
      column_next_contact_date: this.next_contact_date,
      column_service_period_start: this.service_period_start,
      column_service_period_end: this.service_period_end,

      column_agreements: this.agreements
    }
    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('StudentsSearch', setjson)
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.sticky-1 {
  position: sticky;
  z-index: 4;
  top: 0;
  background: #fff;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    top: -1px;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}
.sticky-2 {
  position: sticky;
  z-index: 3;
  top: 26px;
  background: #fff;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}
.sticky-3 {
  position: sticky;
  z-index: 2;
  top: 52px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}

.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 205px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f2bd";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
.men {
  color: #3F51B5;
}
.women {
  color: #E91E63;
}
</style>

<style lang="scss">
.StudentsIndexInheritance {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// StudentsIndexInheritance.vue?2c7e5a24